import React from "react";
import InlineSVG from "react-inlinesvg/esm";
import { WordScrollBox } from "./messages";

export function TypeBot() {
  return (
    <div className="typebot">
      <InlineSVG src="/assets/TypeBot.svg" />
      <WordScrollBox />
    </div>
  );
}
